import { setAppBadgeNumber } from 'acscp/mobile/device/setAppBadgeNumber';
import OneSignal from 'onesignal-cordova-plugin';

export function getPushNotificationId(): Promise<string> {
    return new Promise<string>(resolve => {
        if (window.cordova && window.plugins && window.plugins.OneSignal) { // detect presence of the mobile plugin
            OneSignal.getDeviceState(response => {
                resolve(response.userId);
            });
        } else {
            resolve('');
        }
    });
}

export function enablePushNotifications(): void {
    if (window.cordova && window.plugins && window.plugins.OneSignal) {
        OneSignal.promptForPushNotificationsWithUserResponse(false);
        OneSignal.disablePush(false);
    }
}

export function disablePushNotifications(): void {
    setAppBadgeNumber(0);

    if (window.cordova && window.plugins && window.plugins.OneSignal) {
        OneSignal.disablePush(true);
    }
}
